var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.staticCampaign || _vm.slides.length > 0)?_c('div',{class:_vm.container},[(_vm.staticCampaign)?_c('div',{staticClass:"d-none d-lg-block col-lg-6"},[_c('campaign-content',{attrs:{"variant":_vm.variant,"headline-size":_vm.headlineSize,"campaign":_vm.staticCampaign}})],1):_vm._e(),_vm._v(" "),(_vm.slides.length > 0)?_c('div',{class:[
      'col-12',
      {
        'col-lg-6': !!_vm.staticSlotName
      }
    ]},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"carousel slide",attrs:{"id":(_vm.id + "-indicators")}},[(_vm.slides.length > 1)?_c('ol',{staticClass:"carousel-indicators"},_vm._l((_vm.slides),function(slide,i){return _c('li',{class:{
              'active': i === 0
            },attrs:{"data-target":("#" + _vm.id + "-indicators"),"data-slide-to":i}})}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"carousel-inner"},_vm._l((_vm.slides),function(slide,i){return _c('div',{class:[
              'carousel-item',
              {
                'active': i === 0
              }
            ]},[_c('campaign-content',{attrs:{"variant":_vm.variant,"headline-size":_vm.headlineSize,"campaign":slide.campaign}})],1)}),0)])])]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }